module.exports = ol.tileurlfunction;